// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"a44b2a24","outerContainer":"_41850a02","secondaryToolbar":"_7e284e6b","doorHangerRight":"_1c764a29","toolbarContainer":"_5eae4aa1","toolbarViewerMiddle":"d32b406a","progressBar":"_069e709c","back-to-application":"b0632bfa","root":"cdcd60c7","collapsed":"_3f2101a0","dragging":"_135fa2c4","loader":"_1281f5fe"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/styles.styl
// module id = 5171
// module chunks = 39